import { render, staticRenderFns } from "./EmojiSolidIcon.vue?vue&type=template&id=268fd948&"
import script from "./EmojiSolidIcon.vue?vue&type=script&lang=js&"
export * from "./EmojiSolidIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports